// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"ee601f4f","441":"2b5ff989","558":"ac072dc6","630":"787eb8b6","722":"3c1c962b","872":"a056dd6e","895":"3cbdac7c"}[chunkId] + ".chunk.js";
};